import { getLocalizedStrings } from '../centralizedLocalizedString'; 
import Classes from './CustomerPreference.scss'; 
import SceButton from '../../Common/CommonComponents/sceButton';
import LanguagePopup from './LanguagePopup';
import ReactHtmlParser from 'react-html-parser';
    class LanguageCard extends React.Component {
        constructor(props) {
        super(props);
        this.strings = getLocalizedStrings('CustomerPreference');
        this.state = {
            defaultLanguage: '',editBtnClicked:false,availableLanguages:'',cpcLandingResponse:'',isModifyLangError:false, isLanguageErr: false,
         };
         this.initialPositionValue = window.getComputedStyle(document.body).position;
    }
    
    componentWillMount (){
        if(!_.isEmpty(this.props.cpcResponse)){
            this.setState({ defaultLanguage:this.props.cpcResponse.language, cpcLandingResponse:this.props.cpcResponse, isLanguageErr: this.checkLanguageErr() });}
    }

    checkLanguageErr = () => {
        if(!this.props.cpcResponse.language) return true;
        else {
            for(let i=0; i<this.props.cpcResponse.errorResponseVo.length; i++){
                if(this.props.cpcResponse.errorResponseVo[i].programDetails === 'CPC_PROGRAMS_LANGUAGE') 
                    return this.props.cpcResponse.errorResponseVo[i].errorFlag;
            }
        }
    }
    refreshLanguagePreference = () => {
        app.centralizedService.refreshLanguagePreference().then(
            (response) => {
                this.setState({isLanguageErr: false,defaultLanguage:response.language});
            },
            (error) => {
                this.setState({isLanguageErr: true});
            }
        );
    }

    editBtnClickHandler = () => {
        window.aUtils.sendAAEvent("button","language edit");
        app.centralizedService.getNotificationLanguageList().then(
            (response) => {
            this.setState({availableLanguages:response.languageList, isModifyLangError: false, editBtnClicked: true});
           },(error) => {
            this.setState({editBtnClicked:false});
          });
    }

    onCancelLangHandler = () => {
        this.setState({editBtnClicked:false});}

    onSaveLanguageHandler = (languageSelected,languageCode) => {
        window.aUtils.sendAAEvent("button",languageSelected +" "+ "language save");
        if(!_.isEmpty(languageCode)){
            let reqParams = {};
            reqParams.addressGuid = this.state.cpcLandingResponse.customerDetails[0].addressGuid;
            reqParams.applicationId = '00021';
            reqParams.businessPartnerNumber = this.state.cpcLandingResponse.customerDetails[0].businessPartnerNumber;
            reqParams.language = languageCode;
            reqParams.txnName = 'CPC';
            app.centralizedService.modifyNotificationLanguage(reqParams).then(
                (response) => {
                    if(_.isEmpty(response.errorCode)){
                        this.setState({defaultLanguage:languageSelected,isModifyLangError:false,editBtnClicked:false});
                    }else{
                        this.setState({isModifyLangError:true});
                    }
                },(error) => {
                    this.setState({isModifyLangError:true});
                }
            );
        }else this.setState({editBtnClicked:false});
    }
    overlayFocusController() {
        // to hide the browser scroll bar when clicked outside the pop up
        if(this.state.editBtnClicked) {
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        } else {
            document.body.style.position = this.initialPositionValue;
            document.body.style.removeProperty("width");
        }
    }

    getViewToShow = ()=>{
        if(this.state.editBtnClicked){
            return (
                <div className={Classes.NoficationLanguageCard}>
                    <div className={Classes.alertLabel}>{this.strings.editNotificationLang}</div>
                    <LanguagePopup defaultLanguage={this.state.defaultLanguage} onCancelLangHandler={this.onCancelLangHandler} availableLanguages={this.state.availableLanguages}
                        onSaveLanguageHandler={this.onSaveLanguageHandler} isModifyLangError={this.state.isModifyLangError} refreshLanguagePreference={this.refreshLanguagePreference}
                    />
                </div>
            );
        }else{
            let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
            let viewError;
            if(this.state.isLanguageErr) {            
                viewError = <div>
                                <div className="row sce-space-xs">
                                    <div className="col-xs-12">
                                        <div className={Classes.languageErrSec}>
                                            <img className={Classes.warningIcon} src={warningIcon} alt="Warning Icon" />
                                            <p className={Classes.warningMsg}>{this.strings.languageLodingError}<a onClick={this.refreshLanguagePreference}>{this.strings.RefreshText}</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>;
            }else{
                viewError = <div className={[Classes.marginTop10,Classes.laguageText].join(' ')}>
                                {this.state.defaultLanguage} <button id="NotificationLanguageEdit" className={Classes.EditButton} onClick={this.editBtnClickHandler} >{this.strings.ButtonLabel}</button>
                            </div>;
            }
            return(
                <div>{viewError}</div>
            );
        }
    }

    render(){
        let isMobile = app.appUtil.detectMobile();
        !isMobile ? this.overlayFocusController() : null;
        let view = this.getViewToShow();
        let viewLanguageCard =
            <div>
                <div className={Classes.alertLabel}>
                    {this.strings.OutageLanguage}
                </div>
                <div className={[Classes.alertDescription, Classes.marginTop5].join(' ')}>
                    {ReactHtmlParser(this.props.staticContent.subTxt)}
                </div>
            </div>;
        return(
            <div>
                <div className={[Classes.Cards, Classes.marginBottom20].join(' ')}>
                    {viewLanguageCard}
                    {view}
                </div>
            </div> );
            }
    }
export default LanguageCard;
